import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../css/Automation.css";

const Inboxsettings = () => {
  const [openDropdown, setOpenDropdown] = useState(null);


  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <div className="container-fluid p-4">

      {/* Dropdown 1 */}
      <div className="card mt-4">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(1)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <div className="row">
            <div className="col-md-9">
                <h6>Out of Office Message</h6>
                <p className="small">Set up your working hours and Out Of Office Message. Please note that the Auto Reply gets triggered for new users and users whose conversation is marked closed.</p>
            </div>
            <div className="col-md-3 d-flex align-items-center justify-content-center text-success">
                <h6 className="Status small ">Enabled</h6>
                </div>
                <div className=" col-md-12 d-flex align-items-center justify-content-center">
                <h6 className="small text-success">0 out of Office message sent</h6>
            </div>
            </div>
          </span>

        </div>
        {openDropdown === 1 && (
          <div className="card-body">
          </div>
        )}
      </div>

     
      {/* Dropdown 2 */}
      <div className="card mt-4">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(2)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <div className="row">
            <div className="col-md-9">
                <h6>Welcome Message</h6>
                <p className="small">Configure Greeting message to be triggered when new customers reach out to your business for the first time or existing customers reach out after a period of 24 hours.</p>
            </div>
            <div className="col-md-3 d-flex align-items-center justify-content-center text-success">
                <h6 className="Status small ">Enabled</h6>
                </div>

                <div className=" col-md-12 d-flex align-items-center justify-content-center">
                <h6 className="small text-success">0 out of Office message sent</h6>
            </div>
            </div>
          </span>

        </div>
        {openDropdown === 2 && (
          <div className="card-body">
          </div>
        )}
      </div>
      {/* Dropdown 3 */}
      <div className="card mt-4">
        <div
          className="card-header d-flex justify-content-between"
          onClick={() => toggleDropdown(3)}
          style={{ cursor: "pointer" }}
        >
          <span>
            <div className="row">
            <div className="col-md-9">
                <h6>Delayed Response Message</h6>
                <p className="small">Configure Auto Replies when you are delayed in responding to customer messages. Setup your delay time and the message to be triggered.</p>
            </div>
            <div className="col-md-3 d-flex align-items-center justify-content-center text-success">
                <h6 className="Status small ">Enabled</h6>
                </div>
                <div className=" col-md-12 d-flex align-items-center justify-content-center">
                <h6 className="small text-success">0 out of Office message sent</h6>
            </div>
            </div>

          </span>

        </div>
        {openDropdown === 3 && (
          <div className="card-body">
          </div>
        )}
      </div>

      {/* Dropdown 5 */}
      
    </div>
  );
};

export default Inboxsettings;
